import { Input, InputOnFocus } from '@afterpaytouch/core'
import React, { FunctionComponent } from 'react'
import { useFormContext } from 'react-hook-form'
import { PasswordFieldSchema } from '../../types'
import { useError, useVisible } from '../../utils/hooks'

export const PasswordField: FunctionComponent<PasswordFieldSchema> = ({ name = '', props, options, show = true, testNameSpace = '' }) => {
  const { register } = useFormContext()
  const { isVisible, values } = useVisible({ name, show })
  const { isError, errorText } = useError({ name, error: props?.error, errorText: props?.errorText })
  const component = register(name, {
    ...options,
    value: values ?? props?.value,
    ...(typeof props?.onBlur !== 'undefined' && { onBlur: props?.onBlur }),
  })

  const onBlurHandler = (ev: InputOnFocus): void => {
    component.onBlur(ev)
  }

  return isVisible ? (
    <Input.Password {...component} {...props} onBlur={onBlurHandler} testNameSpace={testNameSpace} error={isError} errorText={errorText} fullWidth />
  ) : null
}
